import type { ComponentType, LazyExoticComponent } from 'react';
import { lazy } from 'react';

/* Definition for Module factory should look like #import */
export type ModuleFactoryAsync<P> = () => Promise<{ default: ComponentType<P> }>;

/* Definition of Module loader, argument is the factory & return a react component, 
   should mimic #next/dynamic & React.lazy */
export type ModuleLoaderAsync<P> = (
    factory: ModuleFactoryAsync<P>,
) => ComponentType<P> | LazyExoticComponent<ComponentType<P>>;

/* Define the loader, by default use React.lazy */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any  */
type ModuleLoaderType = ModuleLoaderAsync<any>; /* (React.lazy uses #any definition) */
let moduleLoader: ModuleLoaderType = lazy;

/* Override the default loader, i.e. next/dynamic */
export function setModuleLoader<P>(loader: ModuleLoaderAsync<P>): void {
    moduleLoader = loader;
}

/* Called throughout ui-workspace to resolve dynamic components, needed as we don't want to
   import next/dynamic here as if there are projects importing ui-workspace & we are rendering
   to the browser, including next/dynamic will result in '__dirname missing' errors, as such,
   we need to ensure all next imports remain in the Next projects only, hence the #setModuleLoader */
function dynamicModuleLoader<P>(factory: ModuleFactoryAsync<P>): ReturnType<ModuleLoaderAsync<P>> {
    const result = moduleLoader(factory);
    return result;
}

export default dynamicModuleLoader;
